<template>
    <b-overlay :show="loading">

      <div class="text-center mt-3 mb-3">
        <h2>Congratulations! <h3>You've earned CE credit.</h3></h2>
        <p style="margin: 0; font-size: 1.2em;">
            Your Exam Grade: {{ examScore }}
        </p>
      </div>

      <template v-if="hasDrilldowns">
        <div class="text-center mt-3 mb-3">
            <h4>Check out our latest 5-Minute Drill Down video!</h4>
            <h6>Fast, focused insights on essential clinical topics.</h6>
        </div>
        <lobby-drilldowns :ch="classHash" :sh="studentHash" :darr="drilldowns"></lobby-drilldowns>
      </template>
      <template v-if="hasPodcasts">
        <div class="text-center mt-3 mb-3">
            <h5>
              If you have a moment, check out the latest podcasts on
              the popular <nobr>Dr. Klein Dental Podcast Show</nobr>
          </h5>
        </div>
        <lobby-podcasts :ch="classHash" :sh="studentHash" :parr="podcasts"></lobby-podcasts>
      </template>
      <div v-if="!hasDrilldowns && !hasPodcasts">
        <!-- No drilldowns or podcasts..? -->
      </div>

    </b-overlay>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import LobbyDrilldowns from "@/components/LobbyDrilldowns"
import LobbyPodcasts from "@/components/LobbyPodcasts"

export default {
  name: 'LobbyExam',  // Used with passed exam page.
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: null,
      busy: false,
      success: false,
      loading: true,
      classHash: null,
      studentHash: null,
      drilldowns: [],
      podcasts: [],
    }
  },
  props: {
    ch: {  //  classes.hash
      type: String,
      default: null
    },
    ph: {  //  podcast.hash
      type: String,
      default: null
    },
    sh: {  // students.hash
      type: String,
      default: null
    },
    examScore: {  // examScore (0-100)
      type: Number,
      default: 0
    }
  },
  components: {
    'lobby-drilldowns': LobbyDrilldowns,
    'lobby-podcasts': LobbyPodcasts
  },
  computed: {
    hasDrilldowns() {
      return (this.drilldowns.length != 0)
    },
    hasPodcasts() {
      return (this.podcasts.length != 0)
    }
  },
  methods: {
  },
  created() {

    this.classHash = this.ch
    this.podcastHash = this.ph
    this.studentHash = this.sh

    if (this.debug) {
      console.log(`Created LobbyExam`)
      console.log( `classHash: ${this.classHash} podcastHash: ${this.podcastHash} studentHash: ${this.studentHash}  examScore  ${this.examScore}`)
    }

    this.loading = true
    service
        .getWebinarLobby(this.classHash, this.podcastHash, this.studentHash, 'exam')
        .then(
            (res => {
                // console.log(`back from getPodcastShow!`);
                if (this.debug) console.log(res)
                if (res.status && res.rowCount !== 0) {
                  if (res.drilldowns.status) {
                    this.drilldowns = res.drilldowns.data
                  }
                  else if (res.podcasts.status) {
                    this.podcasts = res.podcasts.data
                  }
                }
                else {
                    this.error = true
                    this.errorMsg = "Server error. Try later."
                }
            }).bind(this)
        )
        .finally(e => {
            this.loading = false
            if (this.debug) console.log(`finally LobbyExam...`);
        })
        .catch(e => {
            this.error = true
            this.errorMsg = "Error accessing API."
            console.log(e)
        })
  },
  mounted() {
    if (this.debug) console.log(`Mounted LobbyExam`)
    // this.busy = false
    // this.success = false
  },
  beforeDestroy() {
    if (this.debug) console.log(`BeforeDestroy LobbyExam`)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LobbyExam.vue